export class User {
    constructor(roles: string[], isOnline: boolean, fullName: string, userName: string, appAccessToken?: string) {
        this.roles = roles;
        this.isOnline = isOnline;
        this.fullName = fullName;
        this.userName = userName;
        this.appAccessToken = appAccessToken;
    }
    roles: string[];
    isOnline: boolean;
    fullName: string;
    userName: string;
    appAccessToken?: string;
}
